import { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Menu, X, Search } from "lucide-react";
import { Logo } from "../../../../shared/components/Logo";
import { SearchBar } from "../../../../shared/components/SearchBar";
import { Cart } from "../../../../shared/components/Cart";
import { CatalogDropdown } from "../../../../shared/components/CatalogDropdown";
import { useCartStore } from "../../../stores/cartStore";
import { useNavbar } from "../../../../shared/hooks/useNavbar";

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const {
    getItemCount,
    openCart,
  } = useCartStore();

  const { data: navbarData, isLoading: catalogsLoading } = useNavbar();

  return (
    <>
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header principal */}
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <Logo width={140} height={49} />
            </Link>

            {/* Búsqueda - Oculto en móvil, visible en desktop */}
            <div className="hidden md:block flex-1 max-w-md mx-8">
              <SearchBar
                placeholder="Buscar productos..."
                className="w-full"
              />
            </div>

            {/* Navegación desktop */}
            <nav className="hidden lg:flex space-x-8">
              <Link
                to="/"
                className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                Inicio
              </Link>
              <CatalogDropdown />
              <Link
                to="/contact"
                className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                Contacto
              </Link>
            </nav>

            {/* Acciones del lado derecho */}
            <div className="flex items-center space-x-3">
              {/* Botón de búsqueda móvil */}
              <button
                onClick={() => setIsSearchOpen(!isSearchOpen)}
                className="md:hidden p-2 text-gray-700 hover:text-gray-900 transition-colors duration-200 cursor-pointer"
              >
                <Search className="h-5 w-5" />
              </button>

              {/* Carrito */}
              <button
                onClick={openCart}
                className="relative p-2 text-gray-700 hover:text-gray-900 transition-colors duration-200 cursor-pointer"
              >
                <ShoppingCart className="h-5 w-5" />
                {/* Contador del carrito */}
                {getItemCount() > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
                    {getItemCount()}
                  </span>
                )}
              </button>

              {/* Botón de menú móvil */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden p-2 text-gray-700 hover:text-gray-900 transition-colors duration-200 cursor-pointer"
              >
                {isMobileMenuOpen ? (
                  <X className="h-5 w-5" />
                ) : (
                  <Menu className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>

          {/* Búsqueda móvil - Se expande cuando está activa */}
          {isSearchOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <SearchBar
                placeholder="Buscar productos..."
                className="w-full"
              />
            </div>
          )}

          {/* Menú móvil */}
          {isMobileMenuOpen && (
            <div className="lg:hidden border-t border-gray-200">
              <nav className="px-2 pt-2 pb-3 space-y-1">
                <Link
                  to="/"
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Inicio
                </Link>

                {/* Catálogos reales en móvil */}
                {catalogsLoading ? (
                  <div className="px-3 py-2">
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                  </div>
                ) : navbarData?.catalogs && navbarData.catalogs.length > 0 ? (
                  <>
                    <div className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Catálogos
                    </div>
                    {navbarData.catalogs.map((catalog) => (
                      <Link
                        key={catalog.id}
                        to={`/catalog/${catalog.slug}`}
                        state={{ categories: catalog.categories }}
                        className="block px-6 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {catalog.name}
                      </Link>
                    ))}
                  </>
                ) : null}

                <Link
                  to="/contact"
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Contacto
                </Link>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Componente del carrito */}
      <Cart />
    </>
  );
}
